import React, { useEffect, useState } from "react";
import AgGridTable from "../../components/controls/AgGridTable";
import { useTranslation } from "react-i18next";
import OrderModal from "./OrderModal";
import { useAuth } from "../../contexts/AuthContext";

const MyOrdersPage = () => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { currentUser } = useAuth();
  const userId = currentUser?.id;

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Order/ForUser/${userId}`
        );
        const data = await response.json();
        setOrders(data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const columnDefs = [
    {
      headerName: t("orderId"),
      field: "id",
      sortable: true,
      filter: true,
      hide: true,
    },
    {
      headerName: t("stepOne.eventName.label"),
      field: "name",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("stepOne.eventDate.label"),
      field: "eventDate",
      sortable: true,
      filter: true,
      cellRenderer: (params) => new Date(params.value).toLocaleDateString(),
    },
    {
      headerName: t("cart.totalPrice"),
      field: "totalAmount",
      sortable: true,
      filter: true,
      valueFormatter: (params) => `${params.value.toFixed(2)} $`,
    },
    {
      headerName: t("menu.status"),
      field: "status",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        let statusClass = "";
        let statusLabel = "";

        switch (params.value) {
          case "event-in-creation":
            statusClass = "bg-yellow-500 text-black";
            statusLabel = t("status.eventInCreation");
            break;
          case "paid":
            statusClass = "bg-green-500 text-white";
            statusLabel = t("status.paid");
            break;
          case "done":
            statusClass = "bg-red-500 text-white";
            statusLabel = t("status.done");
            break;
          default:
            statusClass = "bg-gray-500 text-white";
            statusLabel = t("status.eventInCreation");
        }

        return (
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${statusClass}`}
          >
            {statusLabel}
          </span>
        );
      },
    },
    {
      headerName: t("providerRequestsGrid.actions"),
      field: "actions",
      cellRenderer: (params) => (
        <button
          onClick={() => openModal(params.data)}
          className="bg-primary text-white px-4 py-2 rounded-full hover:bg-accent transition h-full flex items-center justify-center"
          style={{ height: "100%" }}
        >
          {t("providerRequestsGrid.viewDetails")}
        </button>
      ),
      sortable: false,
      filter: false,
    },
  ];

  const openModal = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedOrder(null);
    setIsModalOpen(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1 className="text-onWhite font-bold text-2xl">
        {t("navbar.myOrders")}
      </h1>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <AgGridTable
          columnDefs={columnDefs}
          rowData={orders}
          pagination={true}
        />
      )}

      {isModalOpen && selectedOrder && (
        <OrderModal
          isOpen={isModalOpen}
          onClose={closeModal}
          orderData={selectedOrder}
          isAdmin={false}
        />
      )}
    </div>
  );
};

export default MyOrdersPage;
